import { render, staticRenderFns } from "./ModalHistoricoEditais.vue?vue&type=template&id=03bd39fc&scoped=true&lang=pug&"
import script from "./ModalHistoricoEditais.vue?vue&type=script&lang=js&"
export * from "./ModalHistoricoEditais.vue?vue&type=script&lang=js&"
import style0 from "./ModalHistoricoEditais.vue?vue&type=style&index=0&id=03bd39fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bd39fc",
  null
  
)

export default component.exports